import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgToggle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.3333 5H8.66667C4.98611 5 2 8.31944 2 12C2 15.6806 4.98611 19 8.66667 19H15.3333C19.0139 19 22 15.6806 22 12C22 8.31944 19.0139 5 15.3333 5ZM15 17C12 17 10 15 10 12C10 9 12 7 15 7C18 7 20 9 20 12C20 15 18 17 15 17Z",
		fill: "currentColor"
	})
});
export default SvgToggle;
